import reviewCard from "./components/reviewCard";

export default {
  path: "review-card/:Code",
  name: "Review Card",
  component: reviewCard,
};
